import { useEffect, useState } from 'react'
import { getCurrentLocale } from '@/providers/I18nProvider'

type Locale = 'vi' | 'en'

export const useLocale = () => {
  const [locale, setLocale] = useState<Locale>('vi')
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    // Get locale from localStorage on mount
    const storedLocale = getCurrentLocale()
    setLocale(storedLocale)
    setIsLoading(false)
  }, [])

  const changeLocale = (newLocale: Locale) => {
    setLocale(newLocale)
    localStorage.setItem('app-locale', newLocale)
  }

  return {
    locale,
    changeLocale,
    isLoading,
  }
}
